import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RoomProduct } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HotelsShopActions, HotelsShopSelectors } from "../../store";

export const useHotelRoomSelection = ({ goToNextStep }) => {
  const { t } = useI18nContext();
  const {
    data: rooms,
    isLoading,
    isError,
  } = useSelector(HotelsShopSelectors.getRooms);

  const dispatch = useDispatch();

  const nightCount = useSelector(HotelsShopSelectors.getTotalNights);

  return useMemo(() => {
    return {
      context: {
        rooms,
        isLoading,
        isError,
        nightCount: nightCount ?? 1,
      },
      handlers: {
        onRoomSelection: (product: RoomProduct) => {
          dispatch(HotelsShopActions.setSelectedRoomProduct(product));
          goToNextStep();
        },
      },
      text: {
        title: t("core-hotels.roomSelection.title"),
        noAvailableRooms: {
          title: t("core-hotels.roomSelection.noAvailableRooms.title"),
          subtitle: t("core-hotels.roomSelection.noAvailableRooms.subtitle"),
        },
      },
    };
  }, [dispatch, goToNextStep, isError, isLoading, nightCount, rooms, t]);
};
